import styled from 'styled-components';

// large courses start
export const LargeOuterContainer = styled.div`
  --tabHeight: 38px;
  --tabTMargin: 8px;
  --tabBMargin: 12px;
  --coursesSectionXPadd: 20px;
  --courseCardsXPadd: 12px;
  --primePricingBtmSpacing: 50px;
  --courseGroupInfoHeight: 60px;

  display: none;
  :focus {
    outline: none;
  }
  @media (min-width: 992px) {
    display: inline-block;
  }
`;

export const LargeInnerContainer = styled.div`
  display: none;
  @media (min-width: 992px) {
    display: block;
    width: var(--layoutWidth);
    max-width: var(--layoutMaxWidth);
    position: absolute;
    top: 60px;
    left: 50%;
    z-index: 1000;
    transition: 0.5s transform, 0.5s opacity;
    transform: scale(0) translateX(-50%);
    opacity: 0;
    ${LargeOuterContainer}:hover & {
      opacity: 1;
      transform: scale(1) translateX(-50%);
    }
  }
`;

export const LargeOuterWrapper = styled.div`
  width: 100%;
  padding: 0px 20px;
  @media (min-width: 992px) {
    padding: 0px;
  }
`;

export const LargeInnerWrapper = styled.div`
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: 30% auto;
  margin: 0px auto;
  background-color: ${(props) => (props.isFromInterview ? '#212020' : props.isDashboard ? props.theme.cardBg : 'white')};
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 2px 10px var(--greyShadowColor);
  height: 440px;
  @media (min-width: 992px) {
    grid-template-columns: 300px auto;
  }
  @media (min-width: 1400px) {
    height: 515px;
  }
  @media (min-width: 1800px) {
    grid-template-columns: 310px auto;
  }
`;

export const LargeNavWrapper = styled.div`
  width: 100%;
  padding: ${({ primePricing }) => (primePricing ? '16px 12px calc(var(--primePricingBtmSpacing) - var(--coursesSectionXPadd) + 24px) 20px' : '16px 12px 16px 20px')};
  overflow-y: auto;
  background-color: ${({ isFromInterview, darkTheme, variant }) =>
    isFromInterview || darkTheme
      ? 'var(--dark)'
      : variant === 'partner-plus'
      ? 'var(--partnerPlusColor)'
      : variant === 'regionals'
      ? 'var(--regionalsColor)'
      : variant === 'code-juniors'
      ? 'var(--codeJuniorsColor)'
      : 'var(--brandColor)'};
  &::-webkit-scrollbar {
    width: 4px;
    display: block;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
  }
  &:hover::-webkit-scrollbar-thumb {
    background: ${(props) => (props.isFromInterview || props.darkTheme ? '#ffffff2a' : '#d2e3ff')};
  }
`;

export const LargeNavBtn = styled.div`
  padding: 6px 24px 6px 8px;
  margin-bottom: 4px;
  position: relative;
  cursor: pointer;
  color: ${({ navActive }) => (navActive ? 'white' : 'var(--light)')};
  &:hover {
    color: ${({ navActive }) => !navActive && '#dadada'};
  }
`;

export const LargeNavTitle = styled.p`
  font-family: var(--headingFont);
  font-size: ${(props) => (props.navActive ? '15px' : '14px')};
  font-weight: ${(props) => props.navActive && 500};
  line-height: ${({ variant }) => !variant === 'regionals' && 'normal'};
`;

export const LargeNavIcon = styled.span`
  position: absolute;
  top: 7px;
  right: 4px;
  color: white;
  line-height: 16px;
  opacity: ${({ navActive }) => (navActive ? '1' : '0')};
  transition: opacity 0.1s;
`;

export const LargeCoursesSection = styled.div`
  position: relative;
  background-color: ${(props) => (props.isFromInterview ? '#212020' : props.isDashboard ? props.theme.cardBg : 'white')};
  padding: ${({ tabview }) => (tabview ? '4px 12px var(--coursesSectionXPadd)' : 'var(--coursesSectionXPadd) 12px')};
  overflow: hidden;
  @media (min-width: 992px) {
    padding: ${({ tabview }) => (tabview ? '4px var(--coursesSectionXPadd) var(--coursesSectionXPadd)' : 'var(--coursesSectionXPadd)')};
  }
`;

export const DurationTabsDivisionWrapper = styled.div`
  margin: var(--tabTMargin) 0px var(--tabBMargin);
  border-bottom: 1px solid var(--greyShadowColor);
`;

export const DurationTabsDivision = styled.div`
  position: relative;
  max-width: 380px;
  display: flex;
  justify-content: center;
  &:after {
    position: absolute;
    display: block;
    left: ${({ selectedTab }) => (selectedTab === 'firstTab' ? '0%' : '50%')};
    bottom: -1px;
    content: '';
    width: 50%;
    height: 2px;
    background: ${({ isFromInterview, darkTheme, variant }) =>
      isFromInterview || darkTheme
        ? 'var(--dark)'
        : variant === 'partner-plus'
        ? 'var(--partnerPlusColor)'
        : variant === 'regionals'
        ? 'var(--regionalsDark)'
        : variant === 'code-juniors'
        ? 'var(--codeJuniorsColor)'
        : 'var(--brandColor)'};
    transition: var(--hoverTransitionDuration);
  }
`;

export const DurationTab = styled.div`
  width: 50%;
  height: var(--tabHeight);
  padding: 0px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  align-content: center;
  line-height: 1.6;
  font-size: 15px;
  font-family: var(--headingFont);
  font-weight: ${({ active }) => (active ? 500 : 400)};
  color: ${({ active, nonclickable }) => (active ? 'var(--inputTxtColor)' : nonclickable ? 'var(--greyColor)' : 'var(--normalTxtColor)')};
  cursor: ${({ nonclickable }) => (nonclickable ? 'default' : 'pointer')};
  transition: color var(--hoverTransitionDuration), background-color var(--hoverTransitionDuration);
`;

export const LargeCoursesWrapper = styled.div`
  width: 100%;
  max-height: ${({ tabview }) => (tabview ? 'calc(100% - calc(var(--tabHeight) +  var(--tabTMargin) + var(--tabBMargin)))' : '100%')};
  padding-top: ${({ topInfo }) => topInfo && 'calc(var(--courseGroupInfoHeight) + 12px)'};
  overflow-y: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  &::-webkit-scrollbar {
    width: 4px;
    display: block;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
  }
  &:hover::-webkit-scrollbar-thumb {
    background: ${(props) => (props.isFromInterview || props.darkTheme ? '#ffffff1a' : '#d2e3ff')};
  }
  @media (min-width: 992px) {
    padding-bottom: ${({ primePricing }) => primePricing && 'calc(var(--primePricingBtmSpacing) - var(--coursesSectionXPadd) + 12px)'};
  }
  @media (min-width: 1400px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

export const LargeCoursesCard = styled.div`
  display: flex;
  align-items: flex-start;
  max-width: 300px;
  padding: var(--courseCardsXPadd);
  margin-bottom: 8px;
  border-radius: 8px;
  background-color: ${(props) => (props.isFromInterview ? '#212020' : props.isDashboard ? props.theme.cardBg : 'white')};
  cursor: ${(props) => (props.nonClickable ? 'default' : 'pointer')};
  :hover {
    background-color: ${(props) => (props.isFromInterview ? '#ffffff33' : props.isDashboard ? props.theme.selectionBg : '#0000000d')};
  }
`;

export const CoursesIcon = styled.img`
  width: 38px;
  margin-right: 10px;
`;

export const LargeCoursesTitle = styled.p`
  color: ${(props) => (props.isFromInterview ? 'var(--light)' : props.isDashboard ? props.theme.txtPrimary : 'var(--normalTxtColor)')};
  font-size: 15px;
  line-height: normal;
  padding-bottom: 4px;
`;

export const LargeCoursesDescription = styled.p`
  color: ${(props) => (props.isFromInterview ? '#d1d1d1' : props.isDashboard ? props.theme.txtSecondary : 'var(--secondary)')};
  font-size: 12px;
`;

export const LargeCoursesGroupInfo = styled.div`
  width: calc(100% - calc(2 * var(--coursesSectionXPadd)));
  height: var(--courseGroupInfoHeight);
  padding: 5px 12px 4px;
  position: absolute;
  top: 16px;
  left: var(--coursesSectionXPadd);
  z-index: 5;
  font-size: 15px;
  line-height: 1.4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: ${({ darkTheme, isFromInterview }) => (darkTheme || isFromInterview ? 'var(--light)' : 'var(--dark)')};
  background: ${({ darkTheme, isFromInterview }) => (darkTheme || isFromInterview ? 'var(--dark)' : 'var(--siteBorderColor)')};
  border-radius: 4px;
}
`;

export const LargeCoursesPrimeBar = styled.div`
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: var(--primePricingBtmSpacing);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px var(--coursesSectionXPadd);
  line-height: 1.4;
  color: var(--inputTxtColor);
  background: ${({ darkTheme, isFromInterview }) => (darkTheme || isFromInterview ? 'var(--yellow)' : 'var(--goldenBgColor)')};
  cursor: pointer;
`;
// large courses end

// large regionals start
export const LargeRegionalsOuterWrapper = styled.div`
  display: none;
  @media (min-width: 992px) {
    display: block;
    position: absolute;
    top: 60px;
    width: 300px;
    padding-bottom: 15px;
    border-radius: 10px;
    background-color: ${(props) => (props.isFromInterview ? '#212020' : props.isDashboard ? props.theme.cardBg : 'white')};
    z-index: 1000;
    overflow: hidden;
    transition: 0.5s transform, 0.5s opacity;
    transform: translateX(-80px) scale(0);
    opacity: 0;
    box-shadow: 0px 2px 10px var(--greyShadowColor);
    ${LargeOuterContainer}:hover & {
      opacity: 1;
      transform: translateX(-110px) scale(1);
    }
  }
`;

export const LargeRegionalsInnerWrapper = styled.div`
  max-height: 380px;
  padding: 15px 15px 0px 15px;
  overflow-y: auto;
  @media (min-width: 1400px) {
    max-height: 400px;
  }
  &::-webkit-scrollbar {
    width: 4px;
    display: block;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
  }
  &:hover::-webkit-scrollbar-thumb {
    background: ${(props) => (props.isFromInterview || props.darkTheme ? '#ffffff1a' : '#d2e3ff')};
  }
`;

export const LargeRegionalsInnerHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-family: var(--headingFont);
  font-weight: 500;
  height: 40px;
  background: ${(props) =>
    props.isFromInterview || props.darkTheme
      ? 'var(--dark)'
      : props.variant === 'partner-plus'
      ? 'var(--partnerPlusColor)'
      : props.variant === 'regionals'
      ? 'var(--regionalsColor)'
      : 'var(--brandColor)'};
`;

export const LargeRegionalsCourse = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 4px;
  color: ${(props) => (props.isFromInterview ? 'var(--light)' : props.isDashboard ? props.theme.txtPrimary : 'var(--normalTxtColor)')};
  background-color: ${(props) => (props.isFromInterview ? '#212020' : props.isDashboard ? props.theme.cardBg : 'white')};
  cursor: pointer;
  :hover {
    background-color: ${(props) => (props.isFromInterview ? '#ffffff33' : props.isDashboard ? props.theme.selectionBg : '#0000000d')};
  }
`;
// large regionals end

// mobile courses start
export const MobileCoursesContainer = styled.div`
  padding: 0px 0px 5px 0px;
`;

export const MobileCourseGroupName = styled.div`
  padding: 12px 16px 12px 20px;
  font-size: 14px;
  font-family: var(--headingFont);
  font-weight: 500;
  color: ${(props) => (props.isFromInterview ? 'var(--siteSecondaryBgColor)' : props.isDashboard && props.darkTheme ? 'var(--siteSecondaryBgColor)' : 'var(--normalTxtColor)')};
`;

export const MobileCourse = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 15px 12px 20px;
  cursor: ${(props) => (props.nonClickable ? 'default' : 'pointer')};
  :hover {
    background: ${(props) => (props.isFromInterview ? '#ffffff1a' : props.isDashboard ? props.theme.selectionBg : '#0000000d')};
  }
`;

export const MobileCourseIcon = styled.img`
  width: 30px;
  margin-right: 10px;
`;
// mobile courses end

export const MobileNavHrLine = styled.hr`
  margin: 8px 0px !important;
  border-top-color: ${(props) => (props.isFromInterview ? '#ffffff33' : props.isDashboard ? props.theme.borderColor : 'var(--greyShadowColor)')};
`;

// mobile regionals starts
export const RegionalCoursesLanguage = styled.div`
  height: 40px;
  padding: 0px 15px 0px 20px;
  font-size: 15px;
  font-family: var(--headingFont);
  color: var(--light);
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.isFromInterview || props.darkTheme
      ? 'var(--dark)'
      : props.variant === 'partner-plus'
      ? 'var(--partnerPlusColor)'
      : props.variant === 'regionals'
      ? 'var(--regionalsColor)'
      : 'var(--brandColor)'};
`;
// mobile regionals end

export const CourseTag = styled.span`
  display: inline-block;
  width: fit-content;
  padding: 2px 6px;
  margin-top: 4px;
  font-size: ${({ specialPrice }) => (specialPrice ? '12px' : '10px')};
  text-transform: uppercase;
  line-height: normal;
  color: ${(props) => (props.earlyAccess ? 'var(--inputTxtColor)' : props.isDashboard ? 'var(--inputTxtColor)' : '#fff')};
  background: ${(props) =>
    props.upComing
      ? 'var(--info)'
      : props.newCourse
      ? 'var(--orange)'
      : props.freeCourse
      ? 'var(--highlightColor)'
      : props.earlyAccess
      ? 'var(--warning)'
      : props.specialOffer || props.specialPrice
      ? 'linear-gradient(90deg, var(--danger),var(--purple))'
      : 'var(--brandColor)'};
  border-radius: 4px;
`;

// regional language dropdown
export const RegionalsLangDropdown = styled.div`
  position: relative;
  display: none;
  :focus {
    outline: none;
  }
  @media (min-width: 992px) {
    display: inline-block;
  }
`;

export const RegionalsLangWrapper = styled.div`
  @media (min-width: 992px) {
    position: absolute;
    top: 60px;
    left: 50%;
    transform: translateX(-50%) scale(0);
    opacity: 0;
    transition: 0.4s transform, 0.4s opacity;
    width: max-content;
    padding: 15px;
    border-radius: 5px;
    background-color: #fff;
    box-shadow: 0px 2px 10px var(--greyShadowColor);
    z-index: 1000;
    ${RegionalsLangDropdown}: hover & {
      transform: translateX(-50%) scale(1);
      opacity: 1;
    }
  }
`;

export const RegionalsLangText = styled.p`
  color: ${(props) => (props.isFromInterview ? 'var(--light)' : props.isDashboard ? props.theme.txtPrimary : 'var(--normalTxtColor)')};
  font-size: 14px;
`;

export const RegionalsLangIcon = styled.img`
  width: 28px;
  margin-right: 10px;
`;
